






















































































import Vue from 'vue';
import { validationMixin } from 'vuelidate';
import { email, minLength, required } from 'vuelidate/lib/validators';
import type { Location } from 'vue-router';

import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import Modal from '~/components/common/Modal/Modal.vue';
import { getValidReferrer } from '~/components/common/SignUpModal/utils';
import type { ModalEmitedEvent } from '~/components/common/Modal/types';
import BravadoTextInputV3 from '~/components/common/BravadoTextInputV3/BravadoTextInputV3.vue';
import ModalBlack from '~/components/common/SignUpModal/ModalBlack/ModalBlack.vue';
import SignUpSocialButtons from '~/components/common/SignUpModal/SignUpSocialButtons/SignUpSocialButtons.vue';
import { isUserInsideExternalApp } from '~/utils/externalRedirections';
import AtIcon from '~/assets/svg/u_at.vue.svg';
import LockIcon from '~/assets/svg/u_lock.vue.svg';

export default Vue.extend({
  name: 'SignInModal',
  components: {
    Modal,
    BravadoTextInputV3,
    AtIcon,
    LockIcon,
    SignUpSocialButtons,
    BravadoButtonV3,
    ModalBlack,
  },
  mixins: [validationMixin],
  data() {
    return {
      form: {
        email: '',
        password: '',
      },
      isUserInsideExternalApp: false,
      isValid: true,
      params: {},
      attemptedSubmission: false,
      loading: false,
    };
  },
  validations: {
    form: {
      email: { required, email },
      password: { required, minLength: minLength(6) },
    },
  },
  computed: {
    emailErrorMessage(): string {
      if (this.isFieldValid('email')) return '';
      if (!this.$v.form.email?.required) return 'Email is required';
      if (!this.$v.form.email.email) return 'Please provide a valid email';

      return '';
    },
    passwordErrorMessage(): string {
      if (this.isFieldValid('password')) return '';
      if (!this.$v.form.password?.required) return 'Password is required';
      if (!this.$v.form.password.minLength) return 'Password must be at least 6 characters long';

      return '';
    },
    linkToSignUp(): Location {
      return { query: { ...this.$route.query, dynamic_modal: this.$constants.dynamicModals.WAR_ROOM_SIGN_UP_MODAL } };
    },
    // Fix typo
    referer(): string {
      const { query } = this.$route;
      return (query.referer || query.refferer) as string;
    },
  },
  mounted() {
    this.isUserInsideExternalApp = isUserInsideExternalApp(
      document.referrer,
      navigator.userAgent,
      this.$device.isWebView,
    );
  },
  methods: {
    handleParamsChange({ params }: ModalEmitedEvent) {
      const { path } = this.$route;
      // eslint-disable-next-line
      const { tab, dynamic_modal, ...rest } = params;
      this.params = { ...rest, refferer: rest.referer || rest.refferer || `${process.env.internalBaseUrl}${path}` };

      if (tab === 'sign-up') {
        this.$router.replace({
          query: { dynamic_modal: 'sign-up', ...rest },
        });
      }
    },
    isFieldValid(fieldName: string) {
      const formElement = this.$v.form[fieldName]!;
      return !(this.attemptedSubmission && formElement.$invalid) && this.isValid;
    },
    async handleLogin() {
      if (this.loading) return;
      if (this.$v.form.$invalid) {
        this.attemptedSubmission = true;
      } else {
        this.loading = true;

        try {
          await this.$auth.login({
            data: {
              user: {
                email: this.form.email,
                password: this.form.password,
              },
            },
          });

          this.$modal.hide(this.$constants.dynamicModals.SIGN_IN_MODAL);

          if (getValidReferrer(this.referer)) {
            window.location.href = this.referer;
          }
        } catch {
          this.isValid = false;

          setTimeout(() => {
            this.isValid = true;
          }, 3000);
        } finally {
          this.loading = false;
        }
      }
    },

    onSocialLogin(provider: 'google' | 'linkedin') {
      this.$analytics.logEvent(`global__sign-in-modal__${provider}-button__click`);
    },
  },
});
